module.exports = __webpack_public_path__ + "static/media/family_11.ef8ecd50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/family/JPEG/family_11.jpg
// module id = 5843
// module chunks = 0